
import IMAGES from '../../../../constants/images';
import styles from "./../Login.module.scss";

const LoginMedantaLogo = () => {
    return (
        <div className={styles.logoWrap}>
            <img className={styles.logoLogin} src={IMAGES.Logo} alt="logo" />
        </div>
    )
}

export default LoginMedantaLogo